
import axios from 'axios';

/**
 * Autentica al usuario con las credenciales de Firmatech.
 * @param {string} user - El username.
 * @param {string} password - El password.
 * @returns {Promise<Object>} - El objeto de respuesta de la solicitud de autenticación.
 */
export async function authFirmatech(user, password) {
    const requestData = { user, password };

    const response = await axios.post(
        `/auth/login`,
        requestData
    );

    return response;
}

/**
 * Intercambia los tokens de acceso.
 * @returns {Promise<Object>} - El objeto de respuesta de la solicitud de intercambio de tokens.
 */
export async function exchangeTokens() {

    const header = { Authorization: "Bearer " + sessionStorage.getItem("refresh_token") };
    const configuration = { headers: header };

    const response = await axios.post(
        `/auth/refresh-token`,
        null,
        configuration
    );

    return response;
}

/**
 * Intercambia los tokens de acceso.
 * @returns {Promise<Object>} - El objeto de respuesta de la solicitud de intercambio de tokens.
 */
export async function getTokens(code, redirect_url) {
    const response = await axios.get(
        `/auth/token/${code}/${encodeURIComponent(redirect_url)}`
    );

    return response;
}

/**
 * Mata los tokens.
 * @returns {Promise<Object>} - El objeto de respuesta de la solicitud de intercambio de tokens.
 */
export async function logoutKeyCloak() {

    try {
        const header = { Authorization: "Bearer " + sessionStorage.getItem("access_token") };
        const configuration = { headers: header };
        const requestData = { refresh_token: sessionStorage.getItem("refresh_token") };
        const response = await axios.post('/auth/logout', requestData, configuration);

    } catch (error) {
        console.error('Error during logout:', error);
    }
}


export function isAdminDev(token) {
  try {
    // 1. Grab the payload (the second part of a JWT: header.payload.signature)
    const base64Url = token.split('.')[1];
    if (!base64Url) return false;

    // 2. Convert URL-safe base64 → standard base64, then decode
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );

    // 3. Parse the JSON and check the partner field
    const { partner } = JSON.parse(jsonPayload);
    return partner === 'Admin_Dev';
  } catch (err) {
    console.error('Unable to decode JWT:', err);
    return false;           // treat any failure as “not Admin_Dev”
  }
}

export function getTokenValue(accessToken, data) {    
    let value = null;
    const tokenData = parseJwt(accessToken);
    if (Object.hasOwnProperty.call(tokenData, data)) {  
      value = tokenData[data];        
    }
    return value;
}

export function parseJwt(token) {
  try {
    // Dividir el token en sus partes
    const base64Url = token.split('.')[1];
    // Reemplazar caracteres especiales de Base64Url
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // Decodificar la cadena Base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error al parsear el JWT:', e);
    return null;
  }
}